// src/store/store.js

import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex)
let store = new Vuex.Store({
    state:{
      webConfig:{},
    },
    getters:{

    },
    mutations:{
        setWebConfig(state, data){
            state.webConfig = data
        },
    },
});

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js